import { createContext, useContext, type ReactNode } from "react";
import { cn } from "./utils";

const FormFieldLabelAccessoryContext = createContext<ReactNode>(null);

/** Supplies a node shown at the end of the next form field label row (e.g. template lock). */
export function FormFieldLabelAccessoryProvider({
    accessory,
    children,
}: {
    accessory: ReactNode;
    children: ReactNode;
}) {
    return (
        <FormFieldLabelAccessoryContext.Provider value={accessory}>{children}</FormFieldLabelAccessoryContext.Provider>
    );
}

export function useFormFieldLabelAccessory(): ReactNode {
    return useContext(FormFieldLabelAccessoryContext);
}

/** Label on the left, optional trailing control on the right (same row). */
export function FormFieldLabelRow({
    label,
    trailing,
    className,
}: {
    label: ReactNode;
    trailing?: ReactNode;
    className?: string;
}) {
    if (trailing == null || trailing === false) {
        return <>{label}</>;
    }

    return (
        <div className={cn("flex items-center w-full min-h-8", className)}>
            <div className="inline-flex flex-wrap items-center gap-x-0.5 gap-y-1 max-w-full">
                <span className="inline-flex [&_label]:inline-flex items-center [&_label]:items-center [&_label]:mb-0 leading-snug">
                    {label}
                </span>
                <span className="inline-flex justify-center items-center h-8 shrink-0">{trailing}</span>
            </div>
        </div>
    );
}
